export const PermissionConstants = {
  MANAGE_APPLICATION_COMMENT_ID: 1,
  MANAGE_APPLICATION_DOCUMENT_ID: 2,
  VIEW_USERS_ID: 3,
  MANAGE_USERS_ID: 4,
  VIEW_REPORTS_ID: 5,
  MANAGE_LOOKUP_LISTS_ID: 6,
  VIEW_APPLICATIONS_ID: 7,
  PERFORM_INITIAL_REVIEW_ID: 8,
  SCHEDULE_PAT_ID: 9,
  CONDUCT_PAT_ID: 10,
  VIEW_PAT_ROSTER_ID: 11,
  ASSIGN_POLYGRAPH_ID: 12,
  SCHEDULE_POLYGRAPH_ID: 13,
  MANAGE_POLYGRAPH_RESULTS_ID: 14,
  MANAGE_PSYCHOLOGICAL_RESULTS_ID: 15,
  ASSIGN_BACKGROUND_INVESTIGATION_ID: 16,
  CONDUCT_BACKGROUND_INVESTIGATION_ID: 17,
  MANAGE_CJBAT_RESULTS_ID: 18,
  MANAGE_GHQ_RESULTS_ID: 19,
  CREATE_NEW_APPLICATION_ID: 20,
  VIEW_APPLICANT_INFORMATION_ID: 21,
  MANAGE_APPLICANT_INFORMATION_ID: 22,
  EDIT_APPLICATION_COMMENTS: 23,
}
